export const locale = {
  lang: "en",
  data: {
    DASHBOARD: "Dashboard",
    GAINS: "Gains",
    RESULTS: "My Results",
    TABLE: {
      SEARCH: "Search",
      SHOW: "Show",
      ENTRIES: "entries",
      DATE: "Date",
      MISSION: "Mission",
      SHOP: "Shop",
      DISTANCE: "Distance (km)",
      CITY: "City",
      STATUS: "Status",
      VALIDATION_DATE: "Validation Date",
      REFUND: "Refund",
      GIFT_VOUCHER: "Gift voucher",
      SALARY: "Salary",
    },
    HOME: {
      DAYS_AGO: "days ago",
      DAYS: "days",
      IN: "In",
      GO_TO_QUESTIONNAIRE: "Go to questionnaire",
      PENDING_ACTIONS: "Pending action(s)",
      YOU_CAN_SUBMIT_THE_QUESTIONNAIRE: "You can submit the questionnaire",
      PROOF_OF_PASSAGE: "Proof of passage",
      SUBMIT_QUESTIONNAIRE: "Submit questionnaire",
      VIEW_THE_BRIEFING: "View the briefing",
      ALL_IS_WELL: "All is well",
      IN_PROGRESS: "In Progress",
      TEXT_IN_PROGRESS:
        "Oops, it looks like you don't have any missions in progress !",
      TO_DO: "To Do",
      TEXT_TO_DO:
        "Oops, it looks like you have nothing to do ! Take a stand on a mission !",
      PROPOSED_MISSIONS: "Proposed Missions",
      TYPE_OF_REWARD: "Type of reward",
      SALARY: "Salary",
      REFUND: "Refund",
      GIFT_VOUCHER: "Gift voucher",
      DISTANCE: "Distance",
      CLEAR_ALL_FILTERS: "Clear All Filters",
      SCENARIO: "Scenario",
      INTERNET_VISIT: "Internet visit",
      DESCRIPTION: "Description",
      NUMBER_OF_QUESTIONS: "Number of questions",
      DATES: "Dates",
      DU:"",
      TO: "to",
      TIME_OF_DAY: "Time of day",
      ADDRESS: "Address",
      POINT_OF_SALE_OF_YOUR_CHOICE: "Point of sale of your choice",
      COMPENSATION: "Compensation",
      SEE_THE_BRIEFING_FOR_MORE_INFORMATION: "See the briefing for more information...",
      VISIT_DATES: "Visit dates",
      DAYS_AVAILABLE_FOR_THE_MISSION: "Days available for the mission",
      SELECT_ALL_THE_DATES_THAT_SUIT_YOU: "Select all the dates that suit you",
      OUR_TEAMS_WILL_ALLOCATE_YOU_ACCORDING_TO_THE_OTHER_ASSIGNMENTS_YOU_HAVE_APPLIED_FOR: "Our teams will allocate you according to the other assignments you have applied for",
      POSITION_YOURSELF: "Position yourself",
    },
    ATTENTION: "ATTENTION",
    CLAIM: "Claim",
    POPOVER_REFUND_P1: "They are automatically transferred to your bank account within 45 days of each mission. The reimbursement may be faster for certain high value missions.",
    POPOVER_REFUND_P2: "you must enter your IBAN in your account otherwise we will not be able to process your refunds.",
    POPOVER_COMPENSATION_P1: "Each time you complete a mission compensated by a gift voucher, it is added to those you have already accumulated from previous missions.",
    POPOVER_COMPENSATION_P2: 'to receive your gift vouchers you must request them by clicking on the "Claim" button.',
    POPOVER_SALARY_P1: "You will receive a salary for all the assignments carried out under a fixed-term contract. The amount of your salary will be automatically transferred to your bank account between the 10th and 15th of the following month if they are completed before the 25th of the month. Otherwise, they will be transferred to the following month.",
    POPOVER_SALARY_P2: "you must enter your IBAN in your account otherwise we will not be able to transfer your wages.",
    REFUNDS: "Refunds",
    CYBERSCORE: "Cyber Score",
    NO_CONFORMITY: "Noncompliance",
    PROCEDURE: "Procedur",
    LOGICIEL: "Logiciels",
    MATERIEL: "Material"
  },
};
